import React, { createContext, useContext, useState } from 'react';

const RolesContext = createContext();

export const useRoles = () => {
  const context = useContext(RolesContext);
  if (!context) {
    throw new Error('useRoles must be used within a RolesProvider');
  }
  return context;
};

export const RolesProvider = ({ children }) => {

  const [roles, setRoles] = useState([
    {
      id: 1,
      function: '',
      role: '',
      employmentType: 'Full-time',
      locationType: 'On-site',
      willRelocate: 'Yes'
    }
  ]);

  // Clear roles when the user changes (token changes)
  React.useEffect(() => {
    const handleStorageChange = () => {
      setRoles([
        {
          id: 1,
          function: '',
          role: '',
          employmentType: 'Full-time',
          locationType: 'On-site',
          willRelocate: 'Yes'
        }
      ]);
    };
    window.addEventListener('storage', handleStorageChange);
    return () => window.removeEventListener('storage', handleStorageChange);
  }, []);

  const addRole = () => {
    if (roles.length < 5) {
      setRoles([
        ...roles,
        {
          id: Date.now(),
          function: '',
          role: '',
          employmentType: 'Full-time',
          locationType: 'On-site',
          willRelocate: 'Yes'
        }
      ]);
    }
  };

  const deleteRole = (id) => {
    setRoles(roles.filter(role => role.id !== id));
  };

  const updateRole = (id, updatesOrField, value) => {
    console.log('Updating role:', id, updatesOrField, value);
    setRoles(roles =>
      roles.map(role => {
        if (role.id === id) {
          if (typeof updatesOrField === 'object') {
            // Batch update
            return { ...role, ...updatesOrField };
          } else {
            // Single field update (backward compatible)
            return { ...role, [updatesOrField]: value };
          }
        }
        return role;
      })
    );
  };

  return (
    <RolesContext.Provider value={{ roles, setRoles, addRole, deleteRole, updateRole }}>
      {children}
    </RolesContext.Provider>
  );
}; 